import type { Payment } from "../types/payments.types";

/**
 * Whether the current user may hand a payment back to the queue: only the operator holding it, or an admin
 * taking the lock away (force release).
 *
 * Single source of truth for both release entry points — the board (drag back to Pendiente) and the card
 * (Liberar button) — so the two can never drift apart.
 */
export function canReleasePayment(
  payment: Payment,
  currentUserId?: string,
  canForceRelease = false,
): boolean {
  if (!payment.takenById) return false;
  if (payment.takenById === currentUserId) return true;
  return canForceRelease;
}

/**
 * Whether releasing this payment means taking the lock away from another operator, which is the admin-only
 * `force-release` endpoint. Derived on every read instead of being captured when the confirmation opens, so a
 * socket update while the modal is open cannot leave the UI calling the wrong endpoint.
 */
export function isForceRelease(payment: Payment, currentUserId?: string): boolean {
  return Boolean(payment.takenById) && payment.takenById !== currentUserId;
}
